import { css } from '@emotion/react';
import { Heading, Text } from '@zapier/design-system';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import pendingWorkspaceAccessImage from '../../../assets/pending-workspace-access.svg';

const rootStyle = css`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: calc(100vh - 60px);
  /* No space token this large; composed from the scale. */
  padding: calc(var(--zds-space-48) + var(--zds-space-32)) var(--zds-space-20)
    var(--zds-space-40);

  @media (max-width: 900px) {
    padding-top: calc(var(--zds-space-48) + var(--zds-space-12));
  }
`;

const cardStyle = css`
  border: var(--zds-border-weak);
  border-radius: var(--zds-radius-large);
  max-width: 800px;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

const contentContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--zds-space-48);
  padding: var(--zds-space-32) var(--zds-space-40);

  @media (max-width: 900px) {
    flex-direction: column;
    gap: var(--zds-space-32);
    padding: var(--zds-space-32) var(--zds-space-24);
  }
`;

const textContentStyle = css`
  display: flex;
  flex-direction: column;
  gap: var(--zds-space-12);
  flex: 1;
  max-width: 380px;

  @media (max-width: 900px) {
    max-width: 100%;
    text-align: center;
  }
`;

const imageContainerStyle = css`
  width: 300px;
  height: 240px;
  flex-shrink: 0;
  position: relative;

  /* Column layout only: a % width avoids a min-content overflow at 320px (SC 1.4.10). */
  @media (max-width: 900px) {
    width: 100%;
    max-width: 280px;
    /* Keep: a fixed height with aspect-ratio brings the 320px overflow back. */
    height: auto;
    aspect-ratio: 5 / 4;
  }

  @media (max-width: 480px) {
    max-width: 240px;
  }
`;

export function PendingWorkspaceAccessPage() {
  const t = useTranslations('pending-workspace-access');

  return (
    <div css={rootStyle}>
      <div css={cardStyle}>
        <div css={contentContainerStyle}>
          <div css={textContentStyle}>
            <Text tag={Heading} type="ParagraphHeader3" color="TextStronger">
              {t('heading')}
            </Text>
            <Text tag="p" type="Body1" color="TextWeaker">
              {t('description')}
            </Text>
          </div>
          <div css={imageContainerStyle}>
            <Image
              src={pendingWorkspaceAccessImage}
              // Decorative: the heading and description already say it.
              alt=""
              fill
              style={{ objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
